import { type TranslationTree } from '@/i18n/types';

export const messages = {
  title: {
    zero: 'Contatos · {{count}}',
    one: 'Contatos · {{count}}',
    other: 'Contatos · {{count}}',
  },
  csv: 'Baixar CSV',
  loadError: 'Não foi possível carregar os contatos',
  empty: 'Nenhum contato ainda. Quem tocar no botão e aceitar compartilhar aparece aqui.',
  columns: {
    name: 'Nome',
    email: 'E-mail',
    phone: 'Telefone',
    consentedAt: 'Aceitou em',
    slot: 'Lugar',
    consentText: 'Texto aceito',
  },
  privacy:
    'Cada pessoa aceitou compartilhar nome, e-mail e telefone com a sua marca. Ninguém vê quem só viu ou clicou.',
  pagination: '{{from}}–{{to}} de {{count}}',
  paginationAria: {
    first: 'Primeira página',
    last: 'Última página',
    next: 'Próxima página',
    previous: 'Página anterior',
  },
} satisfies TranslationTree;
